import { ActivityResponse, Activityurls } from './data-contracts';
import { HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class Activity<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * No description
	 *
	 * @tags activity
	 * @name ActivityDetail
	 * @summary Gets the activity list by query type and parameters.
	 * @request GET:/store/{storeId}/activity
	 * @secure
	 * @response `200` `ActivityResponse` The requested completed successfully.
	 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
	 * @response `401` `void` Not authenticated. The user session is not valid.
	 * @response `403` `void` The user is not authorized to perform the specified request.
	 * @response `404` `void` The specified resource could not be found.
	 * @response `500` `void` Internal server error. For details, see the server log files.
	 */
	activityDetail = (
		storeId: string,
		query: {
			emailPromotionId?: string;
			/** The query name. */
			q: string;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['activityDetail'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/activity`,
				params: _params,
				query: query,
				methodName: 'activityDetail',
			};
			logger.trace(traceData);
		}
		return this.http.request<ActivityResponse, void>({
			path: `/store/${storeId}/activity`,
			method: 'GET',
			query: query,
			secure: true,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
	/**
	 * No description
	 *
	 * @tags activity
	 * @name ActivityUrlsDetail
	 * @summary Resolve email activity urls
	 * @request GET:/store/{storeId}/activity/urls
	 * @secure
	 * @response `200` `Activityurls` The requested completed successfully.
	 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
	 * @response `401` `void` Not authenticated. The user session is not valid.
	 * @response `403` `void` The user is not authorized to perform the specified request.
	 * @response `404` `void` The specified resource could not be found.
	 * @response `500` `void` Internal server error. For details, see the server log files.
	 */
	activityUrlsDetail = (
		storeId: string,
		query?: {
			emailPromotionId?: string;
			urlHeader?: string;
			userId?: string;
			optOutForwardUrl?: string;
			clickedEventUrl?: string;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['activityUrlsDetail'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/activity/urls`,
				params: _params,
				query: query,
				methodName: 'activityUrlsDetail',
			};
			logger.trace(traceData);
		}
		return this.http.request<Activityurls, void>({
			path: `/store/${storeId}/activity/urls`,
			method: 'GET',
			query: query,
			secure: true,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
